export default __webpack_public_path__ + "static/media/herringBone.c638a095.svg";